import React, { Component } from 'react';
import Style from './MobileImage.css';

class MobileImage extends Component{
	render(){
		const allImgs = this.props.imageData.map(curImg => <img key={curImg.id} src={curImg.imgFile} alt={curImg.imgAlt} />);
		return (
			<div style={Style.MobileImage} className="mobile-image">
				{allImgs}
			</div>
		)
	}  
}

export default MobileImage;